// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Calendar: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 42 42">
            <defs>
                <path id="a" d="M0 41.756h41.756V0H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M0 11.953v24.989a4.817 4.817 0 0 0 4.811 4.814h32.131a4.819 4.819 0 0 0 4.814-4.814V11.953a4.816 4.816 0 0 0-4.814-4.811h-2.325v-5.9a1.243 1.243 0 0 0-2.487 0v5.9H9.625v-5.9C9.625.556 9.069 0 8.384 0c-.686 0-1.245.556-1.245 1.242v5.9H4.811A4.815 4.815 0 0 0 0 11.953Zm39.269 24.989a2.328 2.328 0 0 1-2.327 2.327H4.811a2.327 2.327 0 0 1-2.324-2.327V19.443h36.782v17.499ZM36.942 9.625a2.331 2.331 0 0 1 2.327 2.328v5.003H2.487v-5.003a2.33 2.33 0 0 1 2.324-2.328h32.131Z"
                />
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a" />
                </mask>
                <path
                    fill="currentColor"
                    d="M30.345 34.615h2.487v-2.487h-2.487zM8.926 34.615h2.483v-2.487H8.926zM16.068 34.615h2.483v-2.487h-2.483zM23.207 34.615h2.487v-2.487h-2.487zM30.345 26.582h2.487v-2.487h-2.487zM8.926 26.582h2.483v-2.487H8.926zM16.068 26.582h2.483v-2.487h-2.483zM23.207 26.582h2.487v-2.487h-2.487z"
                    mask="url(#b)"
                />
            </g>
        </svg>
    );
};

export default React.memo(Calendar);
